import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src"]

import {
  LoginData,
  emailRules,
  passwordRules,
  digitRules,
} from '@/models/login.model';
import { Actions, ShiftCMSState } from '@/store';
import { UsersActions } from '@/stores/users.store';
import { Ref, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const store = useStore<ShiftCMSState>();
const router = useRouter();

const valid = ref<boolean>(true);
const twoFactorEnabled = ref<boolean>(false);
const twoFactorRequired = ref<boolean>(false);
const digits = ref<string>('');
const loginData = ref<LoginData>({
  email: '',
  password: '',
});

const qrCode = ref<string>('');
const message = ref<string>('');

const enable2FA = async () => {
  const result = await store.dispatch(
    UsersActions.Enable2FACold,
    loginData.value,
  );

  qrCode.value = result.qrCodeDataUrl;
};

const verify2FA = async (isActive: Ref) => {
  const result = await store.dispatch(UsersActions.Verify2FACold, {
    token: digits.value,
    ...loginData.value,
  });
  if (result.twoFactorEnabled) {
    isActive.value = false;
    store.dispatch(Actions.GetCurrentUser);
    message.value = '';
    twoFactorRequired.value = false;
    twoFactorEnabled.value = true;
    store.dispatch(Actions.ShowNotification, {
      message: result.message,
      type: 'success',
    });
  } else {
    message.value = result.message;
  }
};

const login = async () => {
  if (valid.value && digits.value) {
    const data = await store.dispatch(Actions.LoginTwoFactor, {
      ...loginData.value,
      token: digits.value,
    });

    if (data.loggedIn) {
      router.push('/');
      return;
    }
  }

  if (valid.value) {
    const data = await store.dispatch(Actions.Login, loginData.value);

    if (data.loggedIn) {
      router.push('/');
    } else if (data.twoFactorEnabled) {
      twoFactorEnabled.value = true;
    } else if (data.twoFactorRequired) {
      twoFactorRequired.value = true;
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_card, {
    width: "50%",
    class: "mx-auto login-form",
    elevation: "4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        modelValue: valid.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((valid).value = $event)),
        onSubmit: _withModifiers(login, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('login.header')), 1),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "8",
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: loginData.value.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginData.value.email) = $event)),
                        rules: _unref(emailRules),
                        label: "E-mail",
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "8",
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: loginData.value.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginData.value.password) = $event)),
                        rules: _unref(passwordRules),
                        label: _ctx.$t('login.password'),
                        type: "password",
                        required: ""
                      }, null, 8, ["modelValue", "rules", "label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (twoFactorEnabled.value)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        md: "8",
                        class: "mx-auto"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: digits.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((digits).value = $event)),
                            rules: _unref(digitRules),
                            label: _ctx.$t('login.twoFactorCode'),
                            type: "text",
                            required: ""
                          }, null, 8, ["modelValue", "rules", "label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (twoFactorRequired.value)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        md: "2",
                        class: "mx-auto"
                      }),
                      _createVNode(_component_v_col, {
                        md: "6",
                        class: "mx-auto"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, { color: "info" }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("Two Factor is required now to login in as admin. For starters make sure you have an Authenticator app on your phone. Then click the button to continue. ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        md: "4",
                        class: "mx-auto"
                      }, {
                        default: _withCtx(() => [
                          (twoFactorRequired.value)
                            ? (_openBlock(), _createBlock(_component_v_dialog, {
                                key: 0,
                                width: "auto"
                              }, {
                                activator: _withCtx(({ props: activatorProps }) => [
                                  _createVNode(_component_v_btn, _mergeProps(activatorProps, {
                                    class: "mt-11",
                                    type: "button",
                                    color: "info",
                                    onClick: enable2FA
                                  }), {
                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                      _createTextVNode("Enable 2FA")
                                    ])),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(({ isActive }) => [
                                  _createVNode(_component_v_card, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => [
                                          _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Enable Two Factor Authentication", -1)),
                                          _cache[9] || (_cache[9] = _createElementVNode("p", null, [
                                            _createElementVNode("strong", null, "Scan"),
                                            _createTextVNode(" the following QR code with your authenticator app. ")
                                          ], -1)),
                                          _createElementVNode("img", {
                                            src: qrCode.value,
                                            alt: "2FA QR code",
                                            style: {"margin":"0 auto","display":"block"}
                                          }, null, 8, _hoisted_1),
                                          _cache[10] || (_cache[10] = _createElementVNode("p", null, " Provide the 6 digit code and enable two factor authentication on your account. ", -1)),
                                          _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field, {
                                                    modelValue: digits.value,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((digits).value = $event)),
                                                    label: "6 Digit Code"
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn, {
                                                    class: "mt-2",
                                                    color: "success",
                                                    type: "button",
                                                    block: "",
                                                    onClick: () => verify2FA(isActive)
                                                  }, {
                                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                      _createTextVNode("Enable 2FA")
                                                    ])),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (message.value)
                                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                                key: 0,
                                                color: "warning"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(message.value), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { col: "2" }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "mt-2",
                        type: "submit",
                        block: "",
                        textContent: _toDisplayString(_ctx.$t('login.submit'))
                      }, null, 8, ["textContent"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { col: "2" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})